// extracted by mini-css-extract-plugin
export var firstNews = "styles-module--first-news--rJeid";
export var firstNewsContent = "styles-module--first-news-content--hlDLQ";
export var image = "styles-module--image--3WIx1";